<script lang="ts">
    import { overlay } from "../../store"
    import { fly } from "svelte/transition"
    import Search from "../pagebuilder/blocks/Search.svelte"

    $effect(() => {
        if ($overlay.show) document.body.style.overflow = "hidden"
        else document.body.style.overflow = "auto"
    })
    function clickOutside(node: Node, callback: (arg0: Node) => void) {
        // @ts-ignore
        const handleOutsideClick = ({ target }) => {
            if (!node) return
            if (!node.contains(target)) {
                callback(target)
            }
        }

        typeof window !== "undefined" && window.addEventListener("click", handleOutsideClick, true)

        return {
            destroy() {
                typeof window !== "undefined" && window.removeEventListener("click", handleOutsideClick, true)
            },
        }
    }
</script>

{#if $overlay.show}
    <div
        class="sidebar-overlay"
        transition:fly={{ x: 1000 }}
        use:clickOutside={(target) => {
            if (!document.getElementById("dealerLoginIconLink").contains(target)) $overlay.show = false
        }}
    >
        <a
            class="closer"
            href="/"
            aria-label="close"
            onclick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                $overlay.show = false
            }}
        >
            <svg
                aria-label="close"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
            >
                <path
                    d="M6.7583 17.2426L12.0009 12M12.0009 12L17.2435 6.75735M12.0009 12L6.7583 6.75735M12.0009 12L17.2435 17.2426"
                    stroke="#242220"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                ></path>
            </svg>
        </a>
        <div class="pad">
            {#if $overlay.type == "search"}
                <Search />
            {/if}
        </div>
    </div>
{/if}

<style lang="less">
    @import "../../css/variables.less";
    .sidebar-overlay :global {
        .pad {
            padding: 2.4rem;
        }
        position: fixed;
        bottom: 0;
        left: initial;
        right: 0;
        width: 100vw;
        top: 0px;
        overflow-y: scroll;
        overflow-x: hidden;
        z-index: 2000;
        background: var(--bg-100);

        .closer {
            background: var(--bg-100);
            display: flex;
            align-items: center;
            border-bottom: 1px solid var(--dark-100);
            padding: 3px 20px;
            margin-bottom: 20px;
            font-size: 18px;
            height: 65px;
        }

        @media @desktop {
            width: 50vw;
            border-left: 1px solid var(--dark-100);
            overflow-y: auto;
        }
        @media @desktop_large {
            width: 30vw;
        }
    }
</style>
